/**
 * Redirects to a URL, using window.location.href to ensure cookies are processed.
 * Handles iframe contexts by using window.top.location.assign — falling back to
 * window itself when window.top is null (sandboxed iframe) or undefined (some
 * in-app-browser webviews).
 *
 * @param url - The URL to redirect to
 */
export function redirectTo(url: string): void {
  if (typeof window === 'undefined') {
    return
  }

  // window.top is null in a sandboxed iframe and, on some in-app-browser
  // webviews, undefined — neither is a real Window, so fall back to `window`
  // itself (mirrors the ?? idiom already used in social-sign-in-button.tsx).
  const topWindow = window.top ?? window
  const isInIframe = topWindow !== window

  if (isInIframe) {
    topWindow.location.assign(url)
    return
  }

  window.location.href = url
}
